// Importing constants
import closeImgIcon from 'static/images/close.svg';
import LeftArrow from 'static/images/left-arrow.png';

// Importing components
import {
    Description,
    Accordion,
    ChargebackComponents,
    ConditionalComponent,
    Modal,
    AlertModal,
    FakeLoader,
} from 'components';

import { Button } from 'components/form-elements';
import {
    CHARGEBACK_STATUS_ENUM,
    POPUP_ENUM,
    POPUP_TITLE_ENUM,
    CHARGEBACK_UPDATE_TERMINAL_STATE,
    DISPUTE_STATUS_ENUM,
} from '../../utils/constants/commonValues';
import { ChargeBackModalComponents } from '../../components/ChargebackComponents/ChargeBackModalComponents';

// constants
import { META_INFO_ENUM, TRANSACTION_INFO_ENUM } from './constant';

// actions
import {
    fetchChargeBackDetailsRequest,
    chargeBackAgentActionRequest,
    chargeBackMerchantActionRequest,
    fetchDisputeStatusRequest,
    fetchRefundDisputeRequest,
} from './redux/chargeback.actions';

// Importing libs
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useParams, useHistory } from 'react-router-dom';

// styles
import './DisputeDetails.scss';
import './chargebackDetails.scss';

import moment from 'moment';

const ChargeBackStatusView = ({ status }) => {
    return (
        <div className={`button-container-child status ${status}`}>
            {DISPUTE_STATUS_ENUM[status]?.label}{' '}
        </div>
    );
};

ChargeBackStatusView.propTypes = {
    status: PropTypes.string,
    chargeabckLevel: PropTypes.string,
};

const ChargebackDetails = ({ chargebackReduxData, actions, auth }) => {
    const { chargebackId, orderId } = useParams();
    const [popUpComponent, setPopUpComponent] = useState('');

    const history = useHistory();

    const {
        charegebackDetailsData,
        chargebackMerchantAction,
        chargebackAgentAction
    } = chargebackReduxData;
    const {
        transactionData,
        chargebackMetaData,
        disputeDetails
    } = charegebackDetailsData;
        //console.log("🚀 ~ ChargebackDetails ~ disputeDetails:", disputeDetails)
    
    const resetDetailsPage = () => {
        actions.fetchChargeBackDetailsRequest({ orderId,chargebackId, type :"UPI_DISPUTE", disputeId :chargebackId});
    };

    const checkDisputeStatus = () => {
        actions.fetchDisputeStatusRequest({
            id: chargebackId,
            transactionId: transactionData.txnRefNumber,
        });
    };

    const handleComponentSubmit = (component, values) => {
        //console.log("🚀 ~ handleComponentSubmit ~ component:", component)
        //console.log(transactionData ," consoling txn Data");

        
        // console.log(merchantId,txnReferenceId,refundAmount,currency,refundType,isDiputeRefund)
        if (component === POPUP_ENUM.UPDATE_DISPUTE) {  
            actions.fetchRefundDisputeRequest({
                merchantId: transactionData.merchantId,
                txnReferenceId: transactionData.txnRefNumber,
                refundAmount: transactionData.amount,
                currency: "INR",
                refundType: "OFFLINE",
                disputeRefund: true,
            });
            //console.log(values);
        }
    };

    const handleUpdateDisputeClick = () => {
        setPopUpComponent(POPUP_ENUM.UPDATE_DISPUTE);
    };

    useEffect(() => {
        if (chargebackId && orderId) {
            resetDetailsPage();
        }
    }, [chargebackId, orderId]);

    useEffect(() => {
        if(chargebackReduxData.isDisputeUpdatedSucessfully){
            setPopUpComponent('');
        }
        
    },[chargebackReduxData.isDisputeUpdatedSucessfully])

    // Generating meta description data
    const metaDescriptionData =
        transactionData &&
        META_INFO_ENUM.map(item => {
            return { ...item, children: transactionData[item.key] };
        });

    // Generating transaction description data
    const transactionDescriptionData =
        transactionData &&
        TRANSACTION_INFO_ENUM.map(item => {
            return { ...item, children: transactionData[item.key] };
        });
        //console.log("disputeDetails",disputeDetails);
    return (
        <div className="chargeback-details-wrapper">
            <div className="chargeback-header">
                <div className="heading">
                    <img
                        src={LeftArrow}
                        alt="Back"
                        className="leftArrow"
                        onClick={() => {
                            history.goBack();
                        }}
                    />
                    Dispute Details
                </div>
                <div className="button-container">
                    <ChargeBackStatusView
                        status={disputeDetails?.status || 'Nothing'}
                        // status={chargebackMetaData?.currentChargebackStatus}
                        // chargeabckLevel={
                        //     chargebackMetaData?.currentChargebackLevel
                        // }
                    />
                </div>
            </div>

            <div className="chargeback-details">
                <div className="meta-info-container">
                    <Description items={metaDescriptionData} />
                    {/* Rendering meta information */}
                </div>

                <Accordion
                    customClass="rounded-accordion"
                    isOpened={true}
                    isArrowIndicator
                    id="chargeback-details-accordion"
                    upperComponent={
                        <h3 className="page-tile sm">Transaction Details</h3>
                    }
                    lowerComponent={
                        <Description items={transactionDescriptionData} />
                    }
                />

                <Accordion
                    customClass="rounded-accordion"
                    isOpened={true}
                    isArrowIndicator
                    id="chargeback-details-accordion"
                    upperComponent={
                        <h3 className="page-tile sm">Dispute Details</h3>
                    }
                    lowerComponent={
                        <Description items={transactionDescriptionData} />
                    }
                />
            </div>
            
            {disputeDetails?.status?.toLowerCase() !== 'closed' && (
                        <div className="dispute-button-container">
                            <div className="button-container-child">
                                <Button
                                    buttonType="primary"
                                    text="Check Status"
                                    handleClick={checkDisputeStatus}
                                />
                            </div>
                            <ConditionalComponent
                                isVisible={auth?.userDetails?.userLevel === 'MERCHANT'}
                            >
                                <div className="button-container-child">
                                    <Button
                                        buttonType="primary"
                                        text="Update Dispute"
                                        handleClick={handleUpdateDisputeClick}
                                    />
                                </div>
                            </ConditionalComponent>
                        </div>
                    )}

            <Modal
                modalIsOpen={popUpComponent ? true : false}
                closeModal={() => setPopUpComponent(null)}
                customWrapperClass={`content-modal  
                    modal-xl
               `}
            >
                <div className="modal-header">
                    <h2 className="modal-heading">
                        {POPUP_TITLE_ENUM[popUpComponent] || ''}
                    </h2>
                    <img
                        src={closeImgIcon}
                        alt="Close"
                        onClick={() => setPopUpComponent(null)}
                    />
                </div>
                <div className="modal-body">
                    <ChargeBackModalComponents isLoading={chargebackReduxData.isLoading}
                        component={popUpComponent}
                        chargebackMetaData={chargebackMetaData}
                        onClose={() => setPopUpComponent(null)}
                        onSubmit={handleComponentSubmit}
                        // subChargebackDetails={selectedSubChargeback}
                        transactionData={transactionData}
                        chargebackAgentAction={chargebackAgentAction}
                        currentChargebackStatus={
                            chargebackMetaData?.currentChargebackStatus
                        }
                    />
                </div>
            </Modal>
        </div>
    );
};

// PropType validation for Chargeback component
ChargebackDetails.propTypes = {
    actions: PropTypes.object,
    chargebackReduxData: PropTypes.object,
    auth: PropTypes.object,
};

const mapStateToProps = ({ auth, chargebackData }) => ({
    auth,
    chargebackReduxData: chargebackData,
});
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchChargeBackDetailsRequest,
            chargeBackAgentActionRequest,
            chargeBackMerchantActionRequest,
            fetchDisputeStatusRequest,
            fetchRefundDisputeRequest,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChargebackDetails);
